import config from 'config';

if (
  typeof window !== 'undefined' &&
  (process.env.NODE_ENV === 'test' || config.useAPIMocking)
) {
  require('./browser');
}
